module.exports = __webpack_public_path__ + "assets/a91c5cdf3332d437594013973356be8a.png";